import translate from '@/utils/translate';
import {FeatureId} from '@/views/content-studio/constants';

interface TooltipContent {
  headline: string;
  description: string;
  image: string;
  items: {title: string; description: string}[];
}

export default function generateTooltipContent(
  selectedFeature: FeatureId
): TooltipContent {
  const featureToContentMap: Record<FeatureId, TooltipContent> = {
    RESIZE: {
      headline: translate('Choose the Right Videos to Resize'),
      description: translate('Tips for clean, AI-powered reframing'),
      image:
        'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Reframe_Tooltip.png',
      items: [
        {
          title: translate('Well-Framed Shot'),
          description: translate(
            'Clips where the subject is centered and not too close to the edges.'
          ),
        },
        {
          title: translate('Minimal Graphics'),
          description: translate(
            'Videos without overlays or text resize more cleanly.'
          ),
        },
        {
          title: translate('Stable, Bright Clips'),
          description: translate(
            'Well-lit, steady footage keeps the subject clear and easy to track.'
          ),
        },
      ],
    },
    DUB: {
      headline: translate('Choose the Right Videos to Dub'),
      description: translate('Tips to improve dubbing quality and lip sync'),
      image:
        'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Dub_Tooltip.png',
      items: [
        {
          title: translate('Face the Camera'),
          description: translate(
            'Speakers who are front-facing and well-lit sync more accurately.'
          ),
        },
        {
          title: translate('Visible Mouth'),
          description: translate(
            'Lips in clear view improve dubbing alignment.'
          ),
        },
        {
          title: translate('Record in a Quiet Space'),
          description: translate(
            'Low background noise helps maintain clean voice matching.'
          ),
        },
      ],
    },
    REPHRASE: {
      headline: translate('Choose the Right Videos to Rescript'),
      description: translate('Tips to get smooth voice edits'),
      image:
        'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Rephrase_Tooltip.png',
      items: [
        {
          title: translate('Pause Between Lines'),
          description: translate(
            'Clips with natural breaks between sentences for smoother edits.'
          ),
        },
        {
          title: translate('Pause Between Lines'),
          description: translate(
            'Clips with natural breaks between sentences for smoother edits.'
          ),
        },
        {
          title: translate('Minimize Background Noise'),
          description: translate(
            'One clear voice keeps speech clean and in sync.'
          ),
        },
      ],
    },
  };

  return featureToContentMap[selectedFeature] ?? featureToContentMap.RESIZE;
}
